import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect,MultiSelect } from 'vue-search-select'
import Pagination from './../../../../shared/components/pagination'
import AddClient from './../addclient';
import ClientService from '../../../services/clientmanagement.service';
import ServiceforCityandState from '../../../../masterdata/services/masterdata.service';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable'
import moment from 'moment';
import CONSTANT from './../../../../shared/constants/constant';
import ClientView from './clienteview';
import Util from './../../../../shared/util/util';

export default {
  name: 'clientListing',
  components: {
    VueElementLoading,
    Paginate,
    BasicSelect,
    AddClient,
    Pagination,
    CustomExpandableTable,
    ClientView
  },
  props: [],
  data: function() {
    return {
      pageLimit:CONSTANT.PER_PAGE_DATA,
      showAddClient:false,
      selectedAddClientObj : '',
      tableColumn: ['Client System ID', 'Client Business Account ID', 'Company Short/Display Name', 'Company Name','Annual Contract Revision', 'Created By','Created Date','Status ', 'Action'],
      currentPage: 1,
      pageCount: 0,
      pageNo: 0,
      totalrows:0,
      offset:0,
      clientsystemid:'',
      statuslist:[{
        value : true,
        text : 'Active'
      },{
        value : false,
        text : 'Inactive'
      }],
      statusitem:{value:'',text:''},
      status:'',
      companyshortname:'',
      gstnumber:'',
      clientListData : [],
      tableArr : [],
      clientListingflag : false,
      innerTableColumn: ['Client Short Name'],
      selectedEditRow : null,
      useremail :'',
      generalInfo : {},
      legelInfo : {},
      spocInfo : {},
      bankInfo :{},
      viewFlag : false,
      statelist : [],
      generalInfoBlank : 1,
      spocInfoBlank : 1,
      legelInfoBlank : 1,
      bankInfoBlak : 1,
      selectedViewRow : '',
      selectclientSystemID : '',
      selectBusinessAccId: '',
      productlist: [],
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;

    this.clientListingflag = true;
    await Promise.all([
      this.getStateList(),
      this.getProductCategoryList()
    ]);
    this.getClientList();
  },
  methods: {
    selectedStatus(statusitem){
      this.statusitem = statusitem;
      this.status = this.statusitem.value;
    },
    showAddClientPage(){
      this.selectedEditRow = {};
      this.showAddClient = true;
    },
    fileview(index){
      var link = document.createElement('a');
      link.href = index;
      link.setAttribute('target','_blank');
      window.open(index, '_blank');
      link.remove();
      return true;
    },
    async getStateList() {
      try {
        let result = await ServiceforCityandState.getStateList();
        let tempStateList = result.data.data;
        for (var i = 0; i < tempStateList.length; i++) {
          this.statelist.push({
            'id': tempStateList[i].stateid,
            'label': tempStateList[i].statename.toUpperCase()
          })
        }
      } catch (err) {
        this.statelist = [];
      }
    },
    async getProductCategoryList() {
      try {
        let result = await ClientService.getProductCategoryList();
        let tempproductList = result.data.data;
        for (var i = 0; i < tempproductList.length; i++) {
          this.productlist.push({
            'id': tempproductList[i].value,
            'label': tempproductList[i].text
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getCityList(cityid) {
      try {
        let inputPayload = {
          "stateId": [cityid]
        }
        let result = await ServiceforCityandState.getCityList(inputPayload)
        return result.data.data;
      } catch (err) {
        this.citylist = [];
      }
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    format_date(value){
     if (value) {
        return moment(String(value)).format('DD-MM-YYYY HH:mm')
      }
    },
    async getClientList(){
      try {
        let payload = {
          "offset":this.offset,
          "limit": 10
        }
        if (isNaN(this.clientsystemid)) {
          this.$alert("Please Enter Client System ID In Number Format","Client","error");
          return true
        }
        if (this.clientsystemid) {
          payload.clientSystemID = parseInt(this.clientsystemid);
        }
        if (this.status === true) {
          payload.clientStatus = this.status;
        }
        if (this.status === false) {
          payload.clientStatus = this.status;
        }
        if (this.companyshortname) {
          payload.clientShortName = this.companyshortname.trim();
        }
        if (this.gstnumber) {
          payload.gstNumber = this.gstnumber.trim();
        }
        this.clientListingflag = true;
        let result = await ClientService.getClientList(payload);
        this.clientListingflag = false;

        if (result.data.code == 200) {
          let clientdata = result.data.data.rows;
          this.tableArr = result.data.data.rows;
          this.clientListData = [];
          for (var i = 0; i < clientdata.length; i++) {
            this.clientListData.push({
              'Client System ID': clientdata[i].ClientMasterID,
              'Client Business Account ID': clientdata[i].ClientBusinessAccountId,
              'Company Short/Display Name': clientdata[i].ClientShortName,
              'Company Name': clientdata[i].AccountName,
              'Annual Contract Revision': clientdata[i].isannualcontractrevision,
              'Created By' : clientdata[i].CreatedBy,
              'Created Date': this.format_date(clientdata[i].CreatedDate),
              'Status ': ((clientdata[i].IsActive == false) ? 'Inactive' : 'Active') ,
              'id' : clientdata[i].ClientBusinessAccountId
            })
          }
          this.totalrows = result.data.data.count
          if (this.totalrows < 10) {
            this.pageCount = 1
          } else {
            this.pageCount = Math.ceil(this.totalrows / 10);
          }
        }else {
          //this.$alertify.error(result.data.message);
          this.clientListingflag = false;
          this.$alert("Internal Server Error","Client","error");
        }
      } catch (e) {
        this.clientListingflag = false;
        this.$alert(e.message,"Client","error");
      }
    },
    onSubmitSearch(){
      if (this.clientsystemid != '' || this.status !== '' ||
      this.companyshortname  != '' || this.gstnumber != '') {
        this.currentPage = 1;
        this.offset = 0;
        this.getClientList();
      }
    },
  async getCustomTableEvent(event) {
      if(event.actionType == 'edit'){
        let getClientInfo =  this.tableArr.filter(obj => obj.ClientBusinessAccountId === event.id).map(filteredObj => filteredObj);
        this.selectedEditRow = [{
          "ClientSystemID": getClientInfo[0].ClientMasterID,
          "ClientShortName": getClientInfo[0].ClientShortName,
          "IsActive": getClientInfo[0].IsActive,
          "ClientBusinessDetailID": getClientInfo[0].ClientBusinessDetailId,
          "ClientBusinessAccountId": getClientInfo[0].ClientBusinessAccountId,
          "AccountName": getClientInfo[0].AccountName,
          "OldClientMasterId": getClientInfo[0].OldClientMasterId,
        }];
        this.showAddClient = true;
      }
      if (event.actionType == "view")  {
        let clientSystemID = '';
        let clientShortName = '';
        let getClientInfoforview =  this.tableArr.filter(obj => obj.ClientBusinessAccountId === event.id).map(filteredObj => filteredObj);
        for (var i = 0; i < this.clientListData.length; i++) {
          if (this.clientListData[i]['id'] == event.id) {
            clientSystemID = this.clientListData[i]['Client Business Account ID'];
            clientShortName = this.clientListData[i]['Company Short/Display Name'];
          }
        }
        let payload = {
          clientid : clientSystemID
        }
        this.selectclientSystemID = getClientInfoforview[0].ClientMasterID;
        this.selectBusinessAccId = getClientInfoforview[0].ClientBusinessAccountId;
        this.selectedViewRow = payload;
        this.generalInfo = {};
        this.legelInfo = {};
        this.spocInfo = {};
        this.bankInfo = {};
      }
    },
    callParent() {
      this.showAddClient = false;
      this.currentPage = 1;
      this.offset = 0;
      this.getClientList();
    },
    clearForm(){
      this.clientsystemid = '';
      this.status = '';
      this.statusitem = {
        value:'',
        text:''
      };
      this.companyshortname = '';
      this.gstnumber = '';
      this.currentPage = 1;
      this.offset = 0;
      this.getClientList();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * 10
      this.getClientList();
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/client/clientlisting/clientlisting.component.js